/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  function updateCartCurrency() {
    const cartTotalElements = document.querySelectorAll('[data-cart-total-price]');
    
    cartTotalElements.forEach(function(element) {
      const priceText = element.textContent.trim();
      
      // Skip if it's "Free" or already formatted correctly
      if (priceText.toLowerCase() === 'free' || priceText.toLowerCase().includes('free')) {
        return;
      }
      
      // Remove currency codes like EUR, USD, etc. from the end
      const currencyCodeRegex = /\s+[A-Z]{3}$/;
      if (currencyCodeRegex.test(priceText)) {
        element.textContent = priceText.replace(currencyCodeRegex, '');
      }
    });
  }

  function updateCartTitle() {
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    if (!cartDrawer) return;
    
    const titleEmpty = cartDrawer.querySelector('[data-cart-title-empty]');
    const titleWithItems = cartDrawer.querySelector('[data-cart-title-with-items]');
    const itemsQty = cartDrawer.querySelector('[data-cart-items-qty]');
    
    if (titleEmpty && titleWithItems && itemsQty) {
      const hasItems = !itemsQty.classList.contains('hidden');
      
      if (hasItems) {
        titleEmpty.style.display = 'none';
        titleWithItems.style.display = '';
      } else {
        titleEmpty.style.display = '';
        titleWithItems.style.display = 'none';
      }
    }
  }

  // Run currency update with multiple attempts to catch dynamic content
  function runCurrencyUpdate() {
    updateCartCurrency();
    // Run again after delays to catch async content
    setTimeout(updateCartCurrency, 50);
    setTimeout(updateCartCurrency, 200);
    setTimeout(updateCartCurrency, 500);
  }

  document.addEventListener('DOMContentLoaded', function() {
    updateCartCurrency();
    updateCartTitle();
    
    // Listen for cart drawer updates with more aggressive monitoring
    const cartDrawer = document.querySelector('[data-cart-drawer]');
    if (cartDrawer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            runCurrencyUpdate();
            updateCartTitle();
          }
        });
      });
      
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }
    
    // Listen for various cart update events
    const cartEvents = ['cart:updated', 'theme:cart:change', 'ajaxCart:updated', 'cart:refresh'];
    cartEvents.forEach(function(eventName) {
      document.addEventListener(eventName, function() {
        runCurrencyUpdate();
        updateCartTitle();
      });
    });

    // Intercept fetch requests to cart endpoints
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      return originalFetch.apply(this, args).then(function(response) {
        // Check if this is a cart-related request
        const url = args[0];
        if (typeof url === 'string' && (url.includes('/cart') || url.includes('cart.js'))) {
          // Run currency update after cart requests
          setTimeout(runCurrencyUpdate, 100);
        }
        return response;
      });
    };

    // Also listen for any AJAX requests (jQuery or other libraries)
    if (window.jQuery) {
      jQuery(document).ajaxComplete(function(event, xhr, settings) {
        if (settings.url && (settings.url.includes('/cart') || settings.url.includes('cart.js'))) {
          setTimeout(runCurrencyUpdate, 100);
        }
      });
    }
  });
    // Also listen for cart update events
    document.addEventListener('cart:updated', function() {
      updateCartCurrency();
    });

    document.addEventListener('theme:cart:change', function() {
      updateCartCurrency();
    });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

